import React from 'react';
import {
  Clipboard, Landmark, Briefcase, AlertOctagon, Users,
  FileJson, FileArchive, FileText, FileImage, Calendar, Link, File,
} from 'lucide-react';

export const getFolderIcon = (type, size = 15) => {
  switch (type) {
    case 'reporting': return <AlertOctagon height={size} width={size} />;
    case 'captable': return <Clipboard height={size} width={size} />;
    case 'captable_operations': return <Briefcase height={size} width={size} />;
    case 'captable_shareholders': return <Users height={size} width={size} />;
    case 'fundraise': return <Landmark height={size} width={size} />;
    default: return null;
  }
};

export const selectType = (elem, size = 35) => {
  const type = elem?.split('/')[0];
  const subType = elem?.split('/')[1];
  switch (type) {
    case 'application':
      switch (subType) {
        case 'pdf':
        case 'msword':
          return <FileText size={size} />;
        case 'java-archive':
        case 'json':
          return <FileJson size={size} />;
        default:
          return <FileArchive size={size} />;
      }
    case 'image':
      return <FileImage size={size} />;
    case 'text':
      switch (subType) {
        case 'css':
        case 'csv':
        case 'html':
          return <FileJson size={size} />;
        case 'calendar':
          return <Calendar size={size} />;
        default:
          return <FileText size={size} />;
      }
    case 'link':
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      return <Link size={size} />;
    default:
      return <File size={size} />;
  }
};
